import * as React from 'react';

import imagePlaceholder from '@images/image-placeholder.png';

import { getImagePath } from '@app/objects/Image';

const PetMemorialIcon = ({item, index, setCurrentMemorialId}) => {
	const [imgSrc, setImgSrc] = React.useState(item.images[0]);

	React.useEffect(() => {
		setImgSrc(item.images[0]);
	}, []);

	return (
		<a
			onClick={(e) => {
				e.preventDefault();
				setCurrentMemorialId(item.id);
			}}
			key={index} className="pet-memorial-head__pop-icon"
		>
			<img
				src={imgSrc !== imagePlaceholder ? getImagePath(imgSrc, 150, 150) : imgSrc}
				alt="pop-icon"
				onError={() => {
					setImgSrc(imagePlaceholder);
				}}
			/>
		</a>
	);
};

export default PetMemorialIcon;
